import { ComponentRegistryConsumer } from '@bem-react/di';
import React, { Component, ReactChildren, ReactElement } from 'react';

import './index.css';

import cn from 'utils/cn';
import i18n from 'utils/i18n';

const cnLayout = cn('main-layout');

export interface IMainLayoutProps {
    title?: string;
    pageTitle?: string;
    section?: string;
    warningMessageKey?: string;
    transparent: boolean;

    left?: ReactElement;
    right?: ReactElement;
    tail?: ReactElement;
    top?: ReactElement;
    content: string[];

    children: ReactChildren;
}

class MainLayout extends Component<IMainLayoutProps> {
    render() {
        const {
            warningMessageKey,
            pageTitle,
            section,
            transparent,
            tail
        } = this.props;

        let { title } = this.props;

        if (warningMessageKey) {
            const warningMessage = i18n({
                keyset: 'common',
                key: warningMessageKey
            });

            return (
                <section className={cnLayout()}>
                    <div className={cnLayout('warning')}>
                        { warningMessage }
                    </div>
                </section>
            );
        }

        if (section) {
            title = i18n({
                keyset: 'sections',
                key: section
            });
        }

        return (
            <ComponentRegistryConsumer id={'app'}>
                {({ PageTitle }) => (
                    <section className={cnLayout()}>
                        <div className={cnLayout('column')}>
                            { pageTitle && !title && (
                                <PageTitle section={pageTitle} mods={{ align: 'center' }} />
                            )}
                            { title && !pageTitle && (
                                <h1 className={cnLayout('title')}>{title}</h1>
                            )}
                            { this.renderContent(transparent) }
                            {tail}
                        </div>
                    </section>
                )}
            </ComponentRegistryConsumer>
        );
    }

    /* eslint-disable complexity */
    renderContent(transparent: boolean) {
        const { left, right, top, children, content = [] } = this.props;

        const contentElems = content.map(item => {
            switch (item) {
                case 'left':
                    return left
                        ? <aside key={item} className={cnLayout('left')}>{left}</aside>
                        : null;
                case 'middle':
                    return children
                        ? <article key={item} className={cnLayout('middle')}>{children}</article>
                        : null;
                case 'right':
                    return right
                        ? <article key={item} className={cnLayout('right')}>{right}</article>
                        : null;
                case 'top':
                    return top
                        ? <div key={item} className={cnLayout('top')}>{top}</div>
                        : null;
                default:
                    return null;
            }
        });

        return (
            <div className={cnLayout('content', { background: transparent && 'transparent' })}>
                {contentElems}
            </div>
        );
    }
    /* eslint-enable complexity */
}

export default MainLayout;
